module.exports = __webpack_public_path__ + "static/media/tree_5.7cf524ac.jpg";